import { schema } from 'normalizr';

const loyaltyPlanSchema = new schema.Entity('loyaltyPlan');

export default loyaltyPlanSchema;
